document.addEventListener(
  "DOMContentLoaded",
  initEnterpriseGridParallax,
  false
);

function initEnterpriseGridParallax() {
  const enterpriseSection = document.querySelector(".enterprise-section");
  const benefitsSection = document.querySelector(".benefits-section");

  let ticking = false;

  function updateParallax() {
    const scrollY = window.scrollY || window.pageYOffset;

    if (enterpriseSection) {
      const sectionTop = enterpriseSection.offsetTop;
      // Calculate parallax offset (slight movement - 0.2 means it moves at 20% of scroll speed)
      const parallaxOffset = (scrollY - sectionTop) * 0.2;
      // Apply background position via CSS custom property
      enterpriseSection.style.setProperty(
        "--grid-offset-y",
        `${parallaxOffset}px`
      );
    }

    if (benefitsSection) {
      const sectionTop = benefitsSection.offsetTop;
      // Calculate parallax offset (slight movement - 0.2 means it moves at 20% of scroll speed)
      const parallaxOffset = (scrollY - sectionTop) * 0.2;
      // Apply background position via CSS custom property
      benefitsSection.style.setProperty(
        "--grid-offset-y",
        `${parallaxOffset}px`
      );
    }

    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  if (enterpriseSection || benefitsSection) {
    window.addEventListener("scroll", requestTick, { passive: true });
    updateParallax(); // Initial call
  }
}
